import { get, find } from 'lodash/fp';

import config from '../../helpers/config';
import { getLink } from '../../helpers/navigate';
import { getAttributeValueOr } from '../../helpers/getAttributeValue';
import getWindowCategoriesQueryString from '../../helpers/mandi/getWindowCategoriesQueryString';

export default itemId => (dispatch, getState) => {
  const { estimateBuilder } = getState();
  const item = get(`entities.items.byId.${itemId}`)(estimateBuilder);
  const designId = get('designId')(item);

  const windowCategoryMappings = get('mandiAvailability.windowCategoryMappings')(estimateBuilder);
  let category = getAttributeValueOr('unknown', 'category')(item);
  const categoryName = find({ categoryName: category })(windowCategoryMappings);
  if (categoryName) {
    // eslint-disable-next-line prefer-destructuring
    category = categoryName.category;
  }

  return getLink(
    config.plpUrl.mandi,
    {
      params: {
        filters: getWindowCategoriesQueryString(category, windowCategoryMappings),
        itemId,
        designId,
      },
    },
  );
};
